(function($) {
    $(function() {
        $('#newsletterForm').on('submit', function(e) {
            var $this = $(this);
            e.preventDefault();

            $.ajax({
                type: "post",
                context: this,
                dataType: "json",
                url: delizia_localize.ajaxurl,
                data: {
                    action: "newsletter_signup",
                    datas: $this.serializeArray(),
                },
                beforeSend: function(data) {
                    $this.find('.btn-text').css('opacity', '0').addClass('loading');
                    $this.find('.preloader').fadeIn(400);
                },
                success: function(response) {
                    $this.find('.btn-text').css('opacity', '1');
                    $this.find('.preloader').fadeOut(400);
                    var $title = delizia_localize.success_signup;
                    var $contentModal = $('#contentModal .modal-body');

                    if (!response['fault']) {
                        $('#newsletterForm').trigger('reset');
                    } else {
                        $title = delizia_localize.fault;
                    }

                    $contentModal.empty();
                    $contentModal.append('<h1>' + $title + '</h1><p>' + response['msg'] + '</p>');
                    if (!isEmpty($contentModalScroll)) {
                        $contentModalScroll.refresh();
                    }
                    $('#contentModal').modal('show');
                    grecaptcha.reset();
                }
            });
        });

    });
})(jQuery);